import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/projects/';
    const paths = {
        endpointSave: config.endpoints.backend + 'projects/save',
        endpointGetById: config.endpoints.backend + 'projects/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllClients: config.endpoints.backend + 'clients/getall',
        endpointGetAllModalities: config.endpoints.backend + 'projectmodalities/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Projeto",
        labelTitleEdit: "Editar Projeto",
        labelTitleView: 'Visualizar Projeto'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'project_name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_client_id',
                    type: 'select',
                    label: 'Cliente',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllClients,
                        label: 'entity_and_client',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_modality_id',
                    type: 'select',
                    label: 'Modalidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllModalities,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'object',
                    type: 'textarea',
                    label: 'Objeto',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'description',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
